
import { OpcaoEditavel } from '@/dominio/editor/questoes/questao-opcao/opcao/OpcaoEditavel';
import { defineComponent } from 'vue';
import BotoesEdicao from '../../../comum/BotoesEdicao.vue';

export default defineComponent({
    name: 'OpcaoVisualizacao',
    components: { BotoesEdicao },
    props: {
        opcao: { type: OpcaoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        editar() {
            this.$emit('editar', this.opcao);
        },
        excluir() {
            this.$emit('excluir', this.opcao);
        },
        descer() {
            this.$emit('descer', this.opcao);
        },
        subir() {
            this.$emit('subir', this.opcao);
        },
    },
    emits: ['excluir', 'descer', 'subir', 'editar'],
});
